<template>
  <div class="body">
    <img class="Bgc" src="https://p1.ssl.qhimg.com/t01632baf8ad2d85497.png" alt="背景图片" />
    <div class="nav">
      <div class="navTitle">生态伙伴</div>
      <div class="navDesc">ECO-PARTNERS</div>
      <div class="partner">
        <div class="partnerList" v-for="(item,index) in ecoArr" :key="index">
          <img
            :src="item.header_h5_index"
            alt=""
            class="partnerListImg"
          />
          <div class="partnerListBox" >
            <div class="partnerListBoxItem" v-for="(subItem, subIndex) in item.list" :key="subIndex">
              <img
                :src="subItem"
                alt=""
                class="partnerListBoxImg"
              />
            </div>
          </div>
        </div>
      </div>
      <img
      class="iscMore"
      src="https://p0.ssl.qhimg.com/t014dd2729b5fb029e9.png"
      alt="查看更多"
      @click="getMore"
    />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getEcologyPartner } from '@/api/2023/index.js'

const ecoArr=ref([]) //生态伙伴数据

onBeforeMount(async ()=>{
  await getInfo()
})

const getInfo = () => {
  getEcologyPartner()
    .then((res) => {
      ecoArr.value = res.data.data.slice(0,4)
    })
    .catch(() => {})
}

const getMore = () => {
  const path=`${window.location.origin}/new/2023/sponsor.html`
  window.open(path)
}
</script>

<style lang="scss" scoped>
.body {
  position: relative;
  width: 100vw;
  height: 659px;
  .Bgc {
    width: 100%;
    height: 100%;
  }
}

.nav {
  position: absolute;
  top: 36px;
  left: 50%;
  transform: translateX(-50%);
  width: 357px;

  &Title {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    margin: 0 auto;
  }
  &Desc {
    font-size: 11px;
    line-height: 19px;
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    margin: 0 auto 14px;
  }

  .partner {
    background: rgba(58, 38, 12, 0.7);
    &List {
      &Img {
        height: 43px;
        display: block;
        margin: 7px auto 0;
      }
      &Box {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        &Item {
            width: 106px;
            height: 47px;
            margin: 4px 4px 0;
            background-color: #ffffff;
            padding: 6px 14px;
        }
        &Item:nth-child(4) {
          margin-top: 7px;
        }
        &Img {
          width: 100%;
        }
      }
    }
  }

  .partnerList:nth-child(4) {
      height: 123px;
    }
  .iscMore {
    display: block;
    width: 36.4%;
    height: 36px;
    line-height: 36px;
    margin: 18px auto 0;
  }
}
</style>
